module.exports = __webpack_public_path__ + "media/newstyle/images/card-icon-2-568ca54300dea1ec46b48136ba0d4c7f.svg";